import React from "react";
import {
  View,
  Image,
  StyleSheet,
  Animated,
  Easing,
  SafeAreaView,
} from "react-native";

const styles = StyleSheet.create({
  container: {},
  tinyLogo: {
    width: 50,
    height: 50,
  },
});

const Spinner = () => {
  const spinValue = new Animated.Value(0);

  // First set up animation
  Animated.loop(
    Animated.timing(spinValue, {
      toValue: 1,
      duration: 1000000,
      easing: Easing.linear, // Easing is an additional import from react-native
      useNativeDriver: true, // To make use of native driver for performance
    }).start()
  ).start();

  // Next, interpolate beginning and end values (in this case 0 and 1)
  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360000deg"],
  });

  return (
    <View style={styles.container}>
      <Animated.Image
        style={{ width: 50, height: 50, transform: [{ rotate: spin }] }}
        source={require("./spinner.png")}
      />
    </View>
  );
};

export default Spinner;
